if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super()
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        }
        this.mql = window.matchMedia('(min-width: 750px)')
        if (!this.elements.thumbnails) return

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500),
        )
        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false,
                ),
              )
          })
        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        )
          this.removeListSemantic()
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        )
        this.setActiveThumbnail(thumbnail)
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]')
        if (!activeMedia) return
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active')
          })
        activeMedia?.classList?.add('is-active')

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia)

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`,
            )
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail)
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages()
        }

        this.preventStickyHeader()
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft })
          }
          const activeMediaRect = activeMedia.getBoundingClientRect()
          if (activeMediaRect.top > -0.5) return
          const top = activeMediaRect.top + window.scrollY
          window.scrollTo({ top: top, behavior: 'smooth' })
        })
        this.playActiveMedia(activeMedia)

        if (!this.elements.thumbnails) return
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        )
        this.setActiveThumbnail(activeThumbnail)
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition,
        )
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'))
        thumbnail.querySelector('button').setAttribute('aria-current', true)
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft })
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img',
        )
        if (!image) return
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false)
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position,
            )
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true)
          }, 2000)
        }
        image.src = image.src
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia()
        const deferredMedia = activeItem.querySelector('.deferred-media')
        if (deferredMedia) deferredMedia.loadContent(false)
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header')
        if (!this.stickyHeader) return
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return
        this.elements.viewer.slider.setAttribute('role', 'presentation')
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation'),
        )
      }
    },
  )
}

// Continuous Loop Navigation + Desktop Swipe + Mobile Touch - REBUILT LOGIC
;(function () {
  'use strict'

  function init() {
    setTimeout(() => {
      addContinuousLoop()
    }, 1500)
  }

  function addContinuousLoop() {
    const buttons = document.querySelector(
      '.product__media-wrapper .slider-buttons',
    )
    if (!buttons) return

    const prev = buttons.querySelector('.slider-button--prev')
    const next = buttons.querySelector('.slider-button--next')
    const current = buttons.querySelector('.slider-counter--current')
    const slider = document.querySelector('.product__media-list')

    if (!prev || !next || !current || !slider) return

    let currentIndex = 0
    let isAnimating = false

    function getSlides() {
      return Array.from(
        slider.querySelectorAll('.product__media-item:not(.hide-image)'),
      )
    }

    function getCurrentIndex() {
      const slides = getSlides()
      const width = slides[0]?.offsetWidth || 1
      return Math.max(
        0,
        Math.min(Math.round(slider.scrollLeft / width), slides.length - 1),
      )
    }

    function updateCounter(index) {
      if (index === currentIndex) return
      currentIndex = index

      current.style.transition = 'opacity 0.2s ease'
      current.style.opacity = 0
      setTimeout(() => {
        current.textContent = index + 1
        current.style.opacity = 1
      }, 120)
    }

    function scrollToIndex(index) {
      const slides = getSlides()
      const slide = slides[index]
      if (!slide) return

      isAnimating = true
      updateCounter(index)

      slider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      })

      setTimeout(() => {
        isAnimating = false
      }, 600)
    }

    const newNext = next.cloneNode(true)
    const newPrev = prev.cloneNode(true)
    next.replaceWith(newNext)
    prev.replaceWith(newPrev)
    ;[newNext, newPrev].forEach((btn) => {
      btn.classList.remove('slider-button--disabled')
      btn.removeAttribute('disabled')
    })

    newNext.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      const slides = getSlides()
      const nextIndex = (currentIndex + 1) % slides.length
      scrollToIndex(nextIndex)
    })

    newPrev.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      const slides = getSlides()
      let prevIndex = currentIndex - 1
      if (prevIndex < 0) prevIndex = slides.length - 1
      scrollToIndex(prevIndex)
    })

    let scrollTimeout
    slider.addEventListener('scroll', () => {
      if (isAnimating) return
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(() => {
        const newIndex = getCurrentIndex()
        if (newIndex !== currentIndex) {
          updateCounter(newIndex)
        }
      }, 150)
    })

    updateCounter(getCurrentIndex())
    addMouseDragSupport(slider)
    addTouchSwipeSupport(slider)

    function addMouseDragSupport(slider) {
      let isMouseDown = false
      let startX = 0
      let scrollStart = 0
      let wasDragged = false

      slider.style.cursor = 'grab'
      slider.style.userSelect = 'none'

      function startDrag(e) {
        if (e.button !== 0) return
        isMouseDown = true
        startX = e.pageX
        scrollStart = slider.scrollLeft
        wasDragged = false
        slider.style.scrollBehavior = 'auto'
      }

      function moveDrag(e) {
        if (!isMouseDown) return
        e.preventDefault()
        const dragDistance = e.pageX - startX
        slider.scrollLeft = scrollStart - dragDistance
        if (Math.abs(dragDistance) > 10) wasDragged = true
      }

      function endDrag(e) {
        if (!isMouseDown) return
        isMouseDown = false
        slider.style.scrollBehavior = 'smooth'

        if (wasDragged) {
          const dragDiff = e.pageX - startX
          const slides = getSlides()
          let targetIndex = currentIndex

          if (dragDiff < -50) {
            targetIndex = (currentIndex + 1) % slides.length
          } else if (dragDiff > 50) {
            targetIndex = currentIndex - 1
            if (targetIndex < 0) targetIndex = slides.length - 1
          }

          scrollToIndex(targetIndex)
        }
      }

      slider.addEventListener('mousedown', startDrag)
      slider.addEventListener('mousemove', moveDrag)
      slider.addEventListener('mouseup', endDrag)
      slider.addEventListener('mouseleave', endDrag)

      slider.addEventListener(
        'click',
        (e) => {
          if (wasDragged) {
            e.preventDefault()
            e.stopPropagation()
          }
        },
        true,
      )
    }

    function addTouchSwipeSupport(slider) {
      let touchStartX = 0
      let touchMoveX = 0
      let isSwiping = false
      let startIndex = 0

      slider.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].pageX
        touchMoveX = touchStartX
        isSwiping = false
        startIndex = getCurrentIndex()
      })

      slider.addEventListener('touchmove', (e) => {
        touchMoveX = e.touches[0].pageX
        const diff = Math.abs(touchMoveX - touchStartX)
        if (diff > 20) isSwiping = true
      })

      slider.addEventListener('touchend', (e) => {
        if (!isSwiping) return

        const swipeDiff = touchMoveX - touchStartX
        const slides = getSlides()

        // Vänta lite så den vanliga scroll-snappen hinner köra
        setTimeout(() => {
          const newIndex = getCurrentIndex()

          // Om vi var på sista bilden, swipade vänster, men stannade kvar på sista = loopa till första
          if (
            startIndex === slides.length - 1 &&
            newIndex === slides.length - 1 &&
            swipeDiff < -20
          ) {
            scrollToIndex(0)
          }
          // Om vi var på första bilden, swipade höger, men stannade kvar på första = loopa till sista
          else if (startIndex === 0 && newIndex === 0 && swipeDiff > 20) {
            scrollToIndex(slides.length - 1)
          }
        }, 100)
      })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
